module.exports = __webpack_public_path__ + "static/maranganty-a8a2b284b4ce9b713794cc1167be89ec.jpg";